import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("input", {
  id: "toggle-menu",
  type: "checkbox"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  id: "menu-icon",
  for: "toggle-menu"
}, null, -1)
const _hoisted_3 = { id: "content_links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HoverIcon = _resolveComponent("HoverIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("nav", null, [
      _createVNode(_component_router_link, {
        id: "logo",
        to: "/"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_HoverIcon, {
            unhoveredIcon: _ctx.logoWhite,
            hoveredIcon: _ctx.logoAccent
          }, null, 8, ["unhoveredIcon", "hoveredIcon"])
        ]),
        _: 1
      }),
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentRoutes, (route) => {
          return (_openBlock(), _createElementBlock("li", {
            key: route.path,
            class: _normalizeClass({ right: route.path === '/contact' })
          }, [
            _createVNode(_component_router_link, {
              to: route.path
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(route.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ], 2))
        }), 128))
      ])
    ])
  ]))
}